module.exports = __webpack_public_path__ + "static/media/OneEighth.66bbad41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animals/test/OneEighth.jpg
// module id = 886
// module chunks = 0